/**
 * Format a timestamp as "X min ago" / "X hr ago" / "just now".
 * Accepts ISO string or Date; returns a short relative string.
 */
export const timeAgo = (iso) => {
  if (!iso) return null;
  const t = typeof iso === "string" ? new Date(iso) : iso;
  if (Number.isNaN(t.getTime())) return null;
  const diff = Math.max(0, Date.now() - t.getTime());
  const min = Math.floor(diff / 60000);
  if (min < 1) return "just now";
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  return `${day}d ago`;
};
